import { titleSuffix } from "../config";

export function formatDocumentTitle(title: string) {
  return `${title}${titleSuffix}`;
}
